<div class="content-block dx-theme-background-color-as-text-color">
  @if (report.title_hu) {
    <h3>{{ report.title_hu }}</h3>
  }
  @if (report.title_en) {
    <h3>{{ report.title_en }}</h3>
  }
  @if (report.description_hu) {
    <h4>{{ report.description_hu }}</h4>
  }
  @if (report.description_en) {
    <h4>{{ report.description_en }}</h4>
  }
  @if (report.uom_hu) {
    <div class="details">Mértékegység: {{ report.uom_hu }}</div>
  }
  @if (report.uom_en) {
    <div class="details">Unit of measure: {{ report.uom_en }}</div>
  }
  <!--  <div *ngIf="report.description_hu" class="fw-bold">{{ report.description_hu }}</div>-->
  <!--  <div *ngIf="report.description_en" class="fw-bold">{{ report.description_en }}</div>-->
  @if (report.details_hu) {
    <div class="details" [innerHtml]="report.details_hu"></div>
  }
  @if (report.details_en) {
    <div class="details" [innerHtml]="report.details_en"></div>
  }
</div>

<div class="content-block">
  <div class="dx-card responsive-paddings">
    <app-pivot-grid></app-pivot-grid>
    <!-- <ng-container #pivotGridRef></ng-container> -->
  </div>
</div>
